<template>
  <div>
    <Top />
    <!-- tab切换 -->
    <div class="home obor">
      <div class="title">
        <ul class="nav_tab fl">
          <li>
            <span
              title="“一带一路”贸易额指数"
              :class="{onhover:isHover.isOnhover_m}"
              @click="obor_m"
            >“一带一路”贸易额指数</span>
          </li>
          <li>
            <span
              title="“一带一路”集装箱海运量指数"
              :class="{onhover:isHover.isOnhover_h}"
              @click="obor_h"
            >“一带一路”集装箱海运量指数</span>
          </li>
          <li>
            <span
              title="“海上丝绸之路”运价指数"
              :class="{onhover:isHover.isOnhover_j}"
              @click="obor_j"
            >“海上丝绸之路”运价指数</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="home obors">
      <h2 class="bt_title">{{oborTitle}}</h2>
    </div>

    <!-- 图表 -->
    <div class="mapbox">
      <div class="bj_white2 home">
        <div class="button fr">
          <router-link :to="{path: '/exp/expintro', query:{param:'obor'}}" class="btn-blue">指数说明</router-link>
        </div>
        <div class="table_p">
          <div ref="oborLine" id="oborLine" style="margin:0 auto; width:95%; height:100%;"></div>
        </div>
        <p style="padding:0px 25px 10px 0px; font-size:14px;text-align:right">资料来源：上海航运交易所</p>
        <p
          v-show="isHover.isOnhover_h"
          style="padding:0px 25px 10px 0px; font-size:14px;text-align:right"
        >备注：2021年1月起，原“一带一路”货运量指数更改为“一带一路”集装箱海运量指数</p>
      </div>
    </div>

    <!-- 选择框 -->
    <div class="select">
      <div class="screen clearfix">
        <ul class="fl screen_ul clearfix" v-show="isShowArea">
          <li class="fl">
            <strong>区域：</strong>
          </li>
          <el-checkbox-group class="fl" v-model="option">
            <el-checkbox
              v-show="isShowoptions1"
              :label="item.label"
              v-for="item in options1"
              :key="item.id"
            >{{item.label}}</el-checkbox>
            <el-checkbox
              v-show="isShowoptions2"
              :label="item.label"
              v-for="item in options2"
              :key="item.id"
            >{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </ul>
        <div class="fl">
          <el-date-picker
            v-model="oborTime"
            value-format="yyyyMMdd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-value="timeDefaultShow"
            :picker-options="pickerOptions"
            size="small"
          ></el-date-picker>
        </div>
        <div class="button fl">
          <a href="javascript:;" class="btn-blue1" @click="oborSearch">查询</a>
        </div>
        <div class="button fl">
          <a href="javascript:;" class="btn-blue1" @click="oborClear">清空</a>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="p10" style="padding: 0px 10px;">
      <div class="home table">
        <div class="button fr">
          <a href="javascript:;" class="btn-blue1" @click="drawChart">作图</a>
        </div>
        <!-- 表 -->
        <my-table v-show="defaultShow" :col="col" :data="data"></my-table>
        <my-table v-show="undefaultShow" :col="cols" :data="datas"></my-table>
        <p style="padding:12px 25px; font-size:14px;text-align:right">资料来源：上海航运交易所</p>
      </div>
    </div>

    <!-- 画图 -->
    <el-dialog id="chartlog" :visible.sync="chartShow" width="1000px">
      <dtChart ref="mychild" :chartdata="changeChartData"></dtChart>
    </el-dialog>
    <backTop />
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/top";
import Footer from "@/components/footer";
import MyTable from "@/components/MyTable";
import dtChart from "@/components/DrawEcharts";
import backTop from "@/components/BackTop";
import { api } from "@/require/api";
export default {
  components: {
    Top,
    Footer,
    MyTable,
    dtChart,
    backTop
  },
  data() {
    return {
      chartShow: false,
      changeChartData: {
        legend: [],
        xAxis: [],
        series: []
      },
      // 模块
      isHover: {
        isOnhover_m: true,
        isOnhover_h: false,
        isOnhover_j: false
      },
      titleId: 1,
      // 选项
      option: [],
      options1: [
        { id: 20, label: "蒙俄" },
        { id: 21, label: "中亚" },
        { id: 22, label: "南亚" },
        { id: 23, label: "东南亚" },
        { id: 24, label: "西亚" },
        { id: 25, label: "北非" },
        { id: 26, label: "欧洲" },
        { id: 27, label: "大洋洲" }
      ],
      options2: [
        { id: 2, label: "亚洲" },
        { id: 3, label: "中亚" },
        { id: 4, label: "西亚" },
        { id: 5, label: "南亚" },
        { id: 6, label: "东南亚" },
        { id: 7, label: "蒙俄" },
        { id: 8, label: "中东" },
        { id: 9, label: "俄远东" },
        { id: 10, label: "北非" },
        { id: 11, label: "大洋洲" },
        { id: 12, label: "欧洲" }
      ],
      isShowoptions1: true,
      isShowoptions2: false,
      isShowArea: true,
      oborTime: [],
      minTime: "",
      maxTime: "",
      timeDefaultShow: "2020-01",
      pickerOptions: {
        disabledDate: time => {
          this.minTime = "2017-06-30";
          return (
            time.getTime() <= new Date(this.minTime).getTime() ||
            time.getTime() > new Date(this.maxTime).getTime()
          );
        }
      },
      col: [],
      cols: [],
      data: [],
      datas: [],
      defaultShow: true,
      undefaultShow: false,
      oborTitle: "“一带一路”贸易额指数"
    };
  },
  created() {
    this.getOBORInfo();
    this.getdefaultTable();
    this.getTime();
  },
  methods: {
    obor_m() {
      (this.isHover.isOnhover_m = true),
        (this.isHover.isOnhover_h = false),
        (this.isHover.isOnhover_j = false);
      this.titleId = 1;
      this.defaultShow = true;
      this.undefaultShow = false;
      this.isShowArea = true;
      (this.isShowoptions1 = true),
        (this.isShowoptions2 = false),
        this.getdefaultTable();
      this.oborTitle = "“一带一路”贸易额指数";
    },
    obor_h() {
      (this.isHover.isOnhover_m = false),
        (this.isHover.isOnhover_h = true),
        (this.isHover.isOnhover_j = false);
      this.titleId = 2;
      this.defaultShow = true;
      this.undefaultShow = false;
      this.isShowArea = true;
      (this.isShowoptions1 = false),
        (this.isShowoptions2 = true),
        this.getdefaultTable();
      this.oborTitle = "“一带一路”集装箱海运量指数";
    },
    obor_j() {
      (this.isHover.isOnhover_m = false),
        (this.isHover.isOnhover_h = false),
        (this.isHover.isOnhover_j = true);
      this.titleId = 3;
      this.defaultShow = true;
      this.undefaultShow = false;
      this.isShowArea = false;
      this.getdefaultTable();
      this.oborTitle = "“海上丝绸之路”运价指数";
    },
    // 绘制折线图
    async getOBORInfo() {
      const { code, data } = await api.get(
        "/VolumeTradeController/getLineChartInfo",
        {
          titleId: this.titleId
        }
      );
      if (code === 0) {
        let xAxisData = data.time;
        let yAxisData = data.value;
        this.drawline(xAxisData, yAxisData);
      }
    },
    drawline(xAxisData, yAxisData) {
      let oborLine = this.$echarts.init(document.getElementById("oborLine"));
      oborLine.setOption({
        grid: {
          left: "3%",
          right: "4%",
          bottom: "6%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["总指数"]
        },
        xAxis: {
          type: "category",
          data: xAxisData
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "总指数",
            data: yAxisData,
            type: "line",
            areaStyle: {}
          }
        ]
      });
      window.onresize = function() {
        oborLine.resize();
      };
    },
    // 选择框
    async getTime() {
      const { code, data } = await api.get(
        "/VolumeTradeController/getBoxTimes"
      );
      if (code === 0) {
        this.minTime =
          data.startTime.toString().slice(0, 4) +
          "-" +
          data.startTime.toString().slice(4, 6) +
          "-" +
          data.startTime.toString().slice(6, 8);
        this.maxTime =
          data.endTime.toString().slice(0, 4) +
          "-" +
          data.endTime.toString().slice(4, 6) +
          "-" +
          data.endTime.toString().slice(6, 8);
      }
    },
    // 清空
    oborClear() {
      this.option = [];
      this.oborTime = [];
      this.getdefaultTable();
      this.defaultShow = true;
      this.undefaultShow = false;
    },
    // 表格
    async getdefaultTable() {
      (this.option = []),
        (this.oborTime = []),
        (this.col = []),
        (this.data = []);
      const { code, data } = await api.get(
        "/VolumeTradeController/getDefaultTableInfo",
        {
          titleId: this.titleId
        }
      );
      if (code === 0) {
        this.col = data.col;
        this.data = data.data;
        this.changeChartData.legend = data.seriesText;
        this.changeChartData.xAxis = data.xAxis;
        this.changeChartData.series = data.seriesData;
      }
    },
    oborSearch() {
      if (this.titleId === 1 || this.titleId === 2) {
        if (this.option.length === 0) {
          this.$message({
            message: "请选择区域",
            type: "warning"
          });
          return;
        } else if (this.oborTime.length === 0) {
          this.$message({
            message: "请选择时间",
            type: "warning"
          });
          return;
        }
      } else {
        if (this.oborTime.length === 0) {
          this.$message({
            message: "请选择时间",
            type: "warning"
          });
          return;
        }
      }
      this.defaultShow = false;
      this.undefaultShow = true;
      this.getOBORTable();
    },
    async getOBORTable() {
      (this.col = []), (this.data = []);
      const { code, data } = await api.post(
        "/VolumeTradeController/getVTSelectiveTable",
        {
          titleId: this.titleId,
          indicatorNames: this.option,
          startTid: this.oborTime[0],
          endTid: this.oborTime[1]
        }
      );
      if (code === 0) {
        this.cols = data.col;
        this.datas = data.data;
        this.changeChartData.legend = data.seriesText;
        this.changeChartData.xAxis = data.xAxis;
        this.changeChartData.series = data.seriesData;
      }
    },
    // 作图
    drawChart() {
      // console.log(this.changeChartData);
      this.chartShow = true;
      if (this.$refs.mychild) {
        this.$refs.mychild.drawLine_Bar(1);
      }
    }
  },
  watch: {
    // 点击切换模块高亮样式
    isHover: {
      deep: true,
      // immediate: true,
      handler: function(newV, oldV) {
        this.getOBORInfo();
      }
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/exp.less";
/deep/.guides {
  display: none !important;
}
</style>